var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42107 9.33125H13.4742L28.0002 1.30443C28.3584 1.10461 28.7647 0.999638 29.1783 1C29.5919 1.00036 29.9982 1.10604 30.356 1.30649C30.7139 1.50695 31.0107 1.79507 31.2165 2.14171C31.4223 2.48836 31.5299 2.88128 31.5284 3.28092V25.004C31.5286 25.3986 31.4229 25.7864 31.2214 26.1295C31.0199 26.4727 30.7297 26.7595 30.3791 26.9618C30.0285 27.164 29.6295 27.2749 29.2212 27.2835C28.813 27.2921 28.4095 27.1981 28.0501 27.0108L13.4742 19.401H3.42107C2.77898 19.401 2.16315 19.1546 1.70912 18.716C1.2551 18.2773 1 17.6823 1 17.0619V11.6644C0.999999 11.3575 1.06275 11.0536 1.1845 10.7702C1.30624 10.4867 1.48469 10.2291 1.70958 10.0124C1.93447 9.79569 2.20138 9.62404 2.49507 9.50715C2.78876 9.39026 3.10344 9.33046 3.42107 9.33125V9.33125Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89941 19.5981L8.06326 31H13.4057L11.4602 21.6313",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19L13 10",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5283 17.4851C32.4491 17.4851 33.3323 17.1317 33.9834 16.5026C34.6346 15.8735 35.0003 15.0202 35.0003 14.1305C35.0003 13.2408 34.6346 12.3876 33.9834 11.7585C33.3323 11.1294 32.4491 10.7759 31.5283 10.7759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2725 3L26.2725 26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.7e8de2a854d8818cf4e63717604d179e.svg";
export { ForwardRef as ReactComponent };